import React from "react";
import InformationBox from "../../../../components/other/informationBox";
import Chip from "@mui/material/Chip";
import moment from 'moment';
import config from '../../../../app/config';

export function patientBanner(patient, small, fromScreen) {
    let className = small ? "infoPt-small" : "infoPt";
    return (
        <div style={{marginBottom: 10}}>
            {!fromScreen &&
                <InformationBox type="warning">
                    Please confirm this is patient you are looking for.
                </InformationBox>
            }

            <Chip
                className={className}
                label={`Patient: ${patient?.patient?.familyName} ${patient?.patient?.firstName}`}
            />
            <Chip
                className={className}
                label={`DOB: ${patient?.patient?.dob ? moment(patient?.patient?.dob).format(config.defaultDateFormat) : "Unknown"}`}
            />
            <Chip
                className={className}
                label={`Gender: ${patient?.patient?.gender ? patient?.patient?.gender : "Unknown"}`}
            />
            <Chip
                className={className}
                label={`Hospital Number: ${patient?.patient?.hospitalNumber ? patient?.patient?.hospitalNumber : "Not provided"}`}
            />
            <Chip
                className={className}
                label={`NHS Number: ${patient?.patient?.nhsNumber ? patient?.patient?.nhsNumber : "Not provided"}`}
            />
        </div>
    );
}